/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default ($) => {
  const {
    colors,
    themeColors,
    gridBreakpoints,
    fontFamilySansSerif,
    fontFamilyMonospace,
  } = $;

  return css`
    :root {
      ${css(Object.entries(colors).map(
        ([color, value]) => `--${color}: ${value};`
      ))}
      ${css(Object.entries(themeColors).map(
        ([color, value]) => `--${color}: ${value};`
      ))}
      ${css(Object.entries(gridBreakpoints).map(
        ([bp, value]) => `--breakpoint-${bp}: ${value};`
      ))}
      --font-family-sans-serif: "${fontFamilySansSerif}";
      --font-family-monospace: "${fontFamilyMonospace}";
    }
  `;
}
